import { IResult } from "../models/HttpResult";

// Functions
import * as Functions from '../functions/common';

// models
import { ProtocolConsumptionConceptValues } from "../models/Entities/Protocols/ProtocolConsumptionConceptValues";
import { NewProtocolConsumptionConceptValue } from "../models/Entities/Protocols/NewProtocolConsumptionConceptValue";

// Base URL
const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'protocols/protocols/consumptions/';

// get all concept values of a protocol consumption
export const GetAllConceptValuesByConsumptionId = async (
    token: string,
    consumptionId: string
): Promise<ProtocolConsumptionConceptValues[]> => {

    /*
    example url
    -> protocols/protocols/consumptions/3fa85f64-5717-4562-b3fc-2c963f66afa6/conceptvalues
    */
    let RequestURL: string = BaseURL + consumptionId + '/conceptvalues';

    try {
        const Response: ProtocolConsumptionConceptValues[] = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
                throw response;
            } else {
                return response.json();
            }
        })
        .then((data: any) => {
            // Este endpoint devuelve el array pelado, pero el resto de la familia
            // responde con el envelope {data}: se aceptan las dos formas.
            return Array.isArray(data) ? data : (data?.data ?? []);
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// get one concept value by id
export const GetConceptValueById = async (
    token: string,
    conceptValueId: number
): Promise<ProtocolConsumptionConceptValues> => {

    /*
    example url
    -> protocols/protocols/consumptions/conceptvalues/12
    */
    let RequestURL: string = BaseURL + 'conceptvalues/' + conceptValueId;

    try {
        const Response: ProtocolConsumptionConceptValues = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
                throw response;
            } else {
                return response.json() as Promise<IResult<ProtocolConsumptionConceptValues>>;
            }
        })
        .then((data: IResult<ProtocolConsumptionConceptValues>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// create a concept value
export const CreateConceptValue = async (
    token: string,
    conceptValue: NewProtocolConsumptionConceptValue
): Promise<ProtocolConsumptionConceptValues> => {

    /*
    example url
    -> protocols/protocols/consumptions/conceptvalues
    */
    let RequestURL: string = BaseURL + 'conceptvalues';

    try {
        const Response: ProtocolConsumptionConceptValues = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            method: 'POST',
            body: JSON.stringify(conceptValue)
        })
        .then((response) => {
            if (!response.ok) {
                throw response;
            } else {
                return response.json() as Promise<IResult<ProtocolConsumptionConceptValues>>;
            }
        })
        .then((data: IResult<ProtocolConsumptionConceptValues>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// update a concept value
export const UpdateConceptValue = async (
    token: string,
    conceptValue: NewProtocolConsumptionConceptValue & { id: number }
): Promise<ProtocolConsumptionConceptValues> => {

    /*
    example url
    -> protocols/protocols/consumptions/conceptvalues
    */
    let RequestURL: string = BaseURL + 'conceptvalues';

    try {
        const Response: ProtocolConsumptionConceptValues = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            method: 'PUT',
            body: JSON.stringify(conceptValue)
        })
        .then((response) => {
            if (!response.ok) {
                throw response;
            } else {
                return response.json() as Promise<IResult<ProtocolConsumptionConceptValues>>;
            }
        })
        .then((data: IResult<ProtocolConsumptionConceptValues>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// delete a concept value
export const DeleteConceptValue = async (
    token: string,
    conceptValueId: number
): Promise<void> => {

    /*
    example url
    -> protocols/protocols/consumptions/conceptvalues/12
    */
    let RequestURL: string = BaseURL + 'conceptvalues/' + conceptValueId;

    try {
        await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            method: 'DELETE'
        })
        .then((response) => {
            if (!response.ok) {
                throw response;
            }
            // El borrado responde solo el envelope de estado, sin entidad.
            return undefined;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );
    } catch (error: any) {
        throw error;
    }
};
